<div class="row" id="main-content">
  <div class="col-sm-9 map-container">
    <div class="map-frame" #mapdiv>
      <div id="map"></div>
    </div>
  </div>
  <div class="col-sm-3 location-list">
    <ul>
      <li>
        <div class="row">
          <div class="col-md-1">
            <input type="radio" [(ngModel)]="selectedLocationId" name="locations" value="" [checked]="selectedLocationId == ''" (change)="onLocationSelected(null)" />
          </div>
          <div class="col-md-10">
            All
          </div>
        </div>
      </li>
      @for (location of locations; track location) {
        <li>
          <div class="row">
            <div class="col-md-1">
              <input type="radio" [(ngModel)]="selectedLocationId" name="locations" value="{{location.id}}" [checked]="selectedLocationId == location.id" (change)="onLocationSelected(location)" />
            </div>
            <div class="col-md-10">
              {{ location.displayName }}
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
</div>